document.addEventListener('DOMContentLoaded', () => {
    const productCards = document.querySelectorAll('.byob-product-col');
    const countEl = document.getElementById('byob-selected-count');
    const progressEl = document.getElementById('byob-progress');
    const addBtn = document.getElementById('byob-add-to-cart');
    const finalPriceEl = document.getElementById('byob-final-price');
    const selectedImageBoxes = document.querySelectorAll('.byob-selected-image');
    const bundleTabs = document.querySelectorAll('.byob-bundle-tab');
    const imageContainer = document.querySelector('.byob-selection-image');
    let selectedVariants = [];
    const activeTab = document.querySelector('.byob-bundle-tab.active');
    let currentBundleCount = Number(activeTab?.dataset.count || 0);
    let currentBundlePrice = Number(activeTab?.dataset.price || 0);

    function formatPrice(price) {
        return '₹' + Number(price).toLocaleString('en-IN');
    }

    function getTotalSelectedQuantity() {
        return selectedVariants.reduce((total, product) => {
            return total + product.quantity;
        }, 0);
    }

    function getSelectedProduct(variantId) {
        return selectedVariants.find(
            item => String(item.id) === String(variantId)
        );
    }

    function resetCard(card) {
        card.classList.remove('is-selected');
        const action = card.querySelector('.byob-product-action');
        if (!action) return;
        action.innerHTML = `
            <button class="add-to-cart-byob" type="button">
                + Add to Box
            </button>
        `;
    }

    function createQuantityPicker(card, quantity) {
        const action = card.querySelector('.byob-product-action');
        if (!action) return;
        const maxQuantityReached = quantity >= 2;
        action.innerHTML = `
            <div class="byob-quantity-picker">
                <button type="button" class="byob-qty-minus" aria-label="Decrease quantity"> - </button>
                <span class="byob-qty-value">${quantity}</span>
                <button type="button" class="byob-qty-plus" aria-label="Increase quantity"${maxQuantityReached ? 'disabled' : ''}> + </button>
            </div>
        `;
    }

    function updateQuantityBadge(card, quantity) {
        let badge = card.querySelector('.byob-quantity-badge');
        if (!badge) {
            badge = document.createElement('div');
            badge.className = 'byob-quantity-badge';
            card.appendChild(badge);
        }
        badge.textContent = quantity;
    }

    function removeQuantityBadge(card) {
        const badge = card.querySelector('.byob-quantity-badge');
        if (badge) {
            badge.remove();
        }
    }

    function addProduct(card) {
        if (card.dataset.available === 'false') {
            return;
        }
        
        const variantId = card.dataset.variantId;
        const image = card.dataset.image;
        const price = Number(card.dataset.price);
        if (!variantId) {
            alert('Variant ID Missing');
            return;
        }

        const totalSelected = getTotalSelectedQuantity();
        if (totalSelected >= currentBundleCount) {
            return;
        }

        const existingProduct = getSelectedProduct(variantId);
        if (existingProduct) {
            if (existingProduct.quantity >= 2) {
                return;
            }
            existingProduct.quantity += 1;
        } else {
            selectedVariants.push({
                id: variantId,
                image: image,
                price: price,
                quantity: 1
            });
        }

        const product = getSelectedProduct(variantId);
        card.classList.add('is-selected');
        createQuantityPicker(card, product.quantity);
        updateQuantityBadge(card, product.quantity);
        updateUI();
        checkBundleComplete();
    }

    function increaseQuantity(card) {
        const variantId = card.dataset.variantId;
        const product = getSelectedProduct(variantId);
        if (!product) {
            return;
        }
        if (product.quantity >= 2) {
            return;
        }

        const totalSelected = getTotalSelectedQuantity();
        if (totalSelected >= currentBundleCount) {
            return;
        }

        product.quantity += 1;
        createQuantityPicker(card, product.quantity);
        updateQuantityBadge(card, product.quantity);
        updateUI();
        checkBundleComplete();
    }

    function decreaseQuantity(card) {
        const variantId = card.dataset.variantId;
        const product = getSelectedProduct(variantId);
        if (!product) {
            return;
        }
        product.quantity -= 1;
        if (product.quantity <= 0) {
            selectedVariants = selectedVariants.filter(
                item => String(item.id) !== String(variantId)
            );
            resetCard(card);
            removeQuantityBadge(card);
        } else {
            createQuantityPicker(card, product.quantity);
            updateQuantityBadge(card, product.quantity);
        }
        updateUI();
    }

    function checkBundleComplete() {
        const totalSelected = getTotalSelectedQuantity();
        if (totalSelected === currentBundleCount && typeof confetti === 'function') {
            confetti({ particleCount: 150, angle: 60, spread: 80, origin: {
                x: 0, y: 0.7
            }});
            confetti({ particleCount: 150, angle: 120, spread: 80, origin: {
                x: 1,
                y: 0.7
            }});
        }
    }

    function updateSelectedImages() {
        selectedImageBoxes.forEach((box, index) => {
            box.innerHTML = '';
            if (index < currentBundleCount) {
                box.style.display = 'flex';
            } else {
                box.style.display = 'none';
            }
        });

        let imageIndex = 0;
        selectedVariants.forEach(product => {
            for (let quantityIndex = 0; quantityIndex < product.quantity; quantityIndex++) {
                if (selectedImageBoxes[imageIndex]) {
                    selectedImageBoxes[imageIndex].innerHTML = `
                        <div class="byob-selected-item">
                            <img src="${product.image}" alt="">
                        </div>
                    `;
                }
                imageIndex++;
            }
        });

        if (currentBundleCount >= 6) {
            imageContainer.classList.add('compact');
        } else {
            imageContainer.classList.remove('compact');
        }
    }

    function updatePrices() {
        const totalSelected = getTotalSelectedQuantity();
        if (totalSelected !== currentBundleCount) {
            finalPriceEl.innerHTML = '';
            return;
        }
        finalPriceEl.innerHTML = `
            <span>${formatPrice(currentBundlePrice)}</span>
        `;
    }

    function updateUI() {
        const totalSelected = getTotalSelectedQuantity();
        countEl.textContent = totalSelected;
        const progressPercentage = currentBundleCount > 0? Math.min((totalSelected / currentBundleCount) * 100, 100): 0;
        progressEl.style.width = progressPercentage + '%';
        addBtn.disabled = totalSelected !== currentBundleCount;
        document.querySelector('.byob-selection-status').innerHTML = `
            <span id="byob-selected-count"> ${totalSelected} </span> /${currentBundleCount} Selected
        `;
        updateSelectedImages();
        updatePrices();
    }

    bundleTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            bundleTabs.forEach(btn => {
                btn.classList.remove('active');
            });
            tab.classList.add('active');
            currentBundleCount = Number(tab.dataset.count);
            currentBundlePrice = Number(tab.dataset.price);
            resetSelections();
        });
    });

    productCards.forEach(card => {
        if (card.dataset.available === 'false') {
            card.classList.add('sold-out');
            const action = card.querySelector('.byob-product-action');
            if (action) {
                action.innerHTML = `
                    <button class="add-to-cart-byob" type="button" disabled> Sold Out </button>
                `;
            }
            return;
        }

        const action = card.querySelector('.byob-product-action');
        if (!action) return;
        action.addEventListener('click', e => {
            const addButton = e.target.closest('.add-to-cart-byob');
            if (addButton) {
                e.preventDefault();
                e.stopPropagation();
                addProduct(card);
                return;
            }
            const plusButton = e.target.closest('.byob-qty-plus');
            if (plusButton) {
                e.preventDefault();
                e.stopPropagation();
                increaseQuantity(card);
                return;
            }

            const minusButton = e.target.closest('.byob-qty-minus');
            if (minusButton) {
                e.preventDefault();
                e.stopPropagation();
                decreaseQuantity(card);
                return;
            }
        });
    });

    function resetSelections() {
        selectedVariants = [];
        productCards.forEach(card => {
            resetCard(card);
            removeQuantityBadge(card);

        });
        updateUI();
    }
    async function refreshCartUI() {
        try {
            await fetch('/cart.js');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', {
                    bubbles: true
                })
            );

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                const response = await fetch('/cart.js');
                const cart = await response.json();
                cartDrawer.renderContents(cart);
            }
        } catch (e) {
            console.log('Cart Refresh Failed', e);
        }
    }

    async function waitForGoKwik() {
        return new Promise(resolve => {
            let tries = 0;
            const interval = setInterval(() => {
                tries++;
                if (window.Gokwik || window.gokwikSdk) {
                    clearInterval(interval);
                    resolve(true);
                    return;
                }

                const gokwikBtn = document.querySelector('#gokwik-buy-now') || document.querySelector('.gokwik-checkout') || document.querySelector('[class*="gokwik"]') || document.querySelector('[id*="gokwik"]');
                if (gokwikBtn) {
                    clearInterval(interval);
                    resolve(true);
                    return;
                }
                if (tries > 30) {
                    clearInterval(interval);
                    resolve(false);
                }
            }, 1000);
        });
    }

    async function openGoKwik() {
        await refreshCartUI();
        await new Promise(resolve =>
            setTimeout(resolve, 3000)
        );
        try {
            if (window.Gokwik && typeof window.Gokwik.checkout === 'function') {
                window.Gokwik.checkout();
                return true;
            }
        } catch (e) {
            console.log(e);
        }
        try {
            if (window.Gokwik && typeof window.Gokwik.openCheckout === 'function') {
                window.Gokwik.openCheckout();
                return true;
            }
        } catch (e) {
            console.log(e);
        }
        const gokwikBtn = document.querySelector('#gokwik-buy-now') || document.querySelector('.gokwik-checkout button') || document.querySelector('.gokwik-checkout') || document.querySelector('[class*="gokwik"] button') || document.querySelector('[class*="gokwik"]') || document.querySelector('[id*="gokwik"]');
        if (gokwikBtn) {
            gokwikBtn.removeAttribute('disabled');
            gokwikBtn.click();
            return true;
        }
        return false;
    }

    addBtn.addEventListener('click', async () => {
        const totalSelected = getTotalSelectedQuantity();
        if (totalSelected !== currentBundleCount) {
            alert(`Please select ${currentBundleCount} products`);
            return;
        }
        try {
            addBtn.disabled = true;
            addBtn.innerHTML = 'Preparing Checkout...';
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            
            if (cartData.items && cartData.items.length > 0) {
                await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
            addBtn.innerHTML = 'Adding Products...';
            const items = selectedVariants.map(item => ({
                id: Number(item.id),
                quantity: Number(item.quantity)
            }));

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items
                })
            });

            if (!response.ok) {
                throw new Error('Add To Cart Failed');
            }

            await new Promise(resolve => setTimeout(resolve, 1000));
            await refreshCartUI();
            window.history.pushState({}, '', window.location.pathname);
            await waitForGoKwik();
            addBtn.innerHTML = 'Opening Checkout...';
            
            const opened = await openGoKwik();
            if (!opened) {
                throw new Error('Unable to open GoKwik checkout');
            }

            const resetAddButton = () => {
                addBtn.disabled = false;
                addBtn.innerHTML = 'Add to Cart';
            };

            document.addEventListener('gokwik:close', resetAddButton, { once: true });
            document.addEventListener('gokwik:closed', resetAddButton, { once: true });
            document.addEventListener('gokwik:checkout:close', resetAddButton, { once: true });
            let checkoutCheckCount = 0;
            const checkoutWatcher = setInterval(() => {
                checkoutCheckCount++;

                const gokwikElements = document.querySelectorAll(
                    '[class*="gokwik"], ' +
                    '[id*="gokwik"], ' +
                    '[class*="GoKwik"], ' +
                    '[id*="GoKwik"]'
                );

                let popupVisible = false;

                gokwikElements.forEach(el => {
                    const style = window.getComputedStyle(el);
                    if (style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity || 1) > 0 && el.offsetWidth > 0 && el.offsetHeight > 0) {
                        popupVisible = true;
                    }
                });

                if (!popupVisible && checkoutCheckCount > 2) {
                    clearInterval(checkoutWatcher);
                    resetAddButton();
                }

                if (checkoutCheckCount >= 600) {
                    clearInterval(checkoutWatcher);
                    resetAddButton();
                }
            }, 1000);
        } catch (error) {
            console.error('BYOB GoKwik Error:', error);
            addBtn.disabled = false;
            addBtn.innerHTML = 'Add to Cart';
            alert('Something went wrong');
        }
    });

    const searchInput = document.querySelector('.byob-search');
    const productContainer = document.querySelector('.byob-main');
    document.querySelectorAll('.byob-product-col').forEach((card, index) => {
        card.dataset.originalIndex = index;
    });

    function debounce(func, delay = 300) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    const handleSearch = debounce((searchValue) => {
        const cards = [...document.querySelectorAll('.byob-product-col')];
        const keyword = searchValue.toLowerCase().trim();
        if (!keyword) {
            cards.sort((a, b) => {
                return (Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));
            });
            cards.forEach(card => {
                card.style.display = '';
                productContainer.appendChild(
                    card
                );
            });
            const noResult = document.querySelector('.search-empty');
            if (noResult) {
                noResult.remove();
            }
            return;
        }
        const matched = [];
        const unmatched = [];
        cards.forEach(card => {
            const title = card.querySelector('.byob-product-title')?.innerText.toLowerCase() || '';
            if (title.includes(keyword)) {
                    matched.push(card);
            } else {
                unmatched.push(card);
            }
        });
        const oldMessage = document.querySelector('.search-empty');
        if (oldMessage) {
            oldMessage.remove();
        }
        [...matched, ...unmatched].forEach(card => {
            productContainer.appendChild(card);
        });
        matched.forEach(card => {
            card.style.display = '';
        });
        unmatched.forEach(card => {
            card.style.display = '';
        });
        if (matched.length === 0) {
            const empty = document.createElement('p');
            empty.className = 'search-empty';
            empty.innerText = 'No products found';
            productContainer.appendChild(empty);
        }
    }, 300);
    if (searchInput) {
        searchInput.addEventListener('input', function (e) {
            handleSearch(e.target.value);
        });
    }

    const showMoreBtn = document.getElementById('byob-show-more');
    let visibleCount = 20;
    const loadCount = 20;
    productCards.forEach((card, index) => {
        if (index >= visibleCount) {
            card.classList.add('hidden-product');
        }
    });
    function loadProducts() {
        const hiddenProducts = document.querySelectorAll('.byob-product-col.hidden-product');
        for ( let i = 0; i < loadCount; i++) {
            if (hiddenProducts[i]) {
                hiddenProducts[i].classList.remove('hidden-product');
            }
        }

        const remainingProducts = document.querySelectorAll('.byob-product-col.hidden-product');
        if (!remainingProducts.length && showMoreBtn) {
            showMoreBtn.style.display = 'none';
        }
    }

    if (showMoreBtn) {
        showMoreBtn.addEventListener('click', loadProducts);
    }

    window.addEventListener('scroll', () => {
        if (!showMoreBtn) return;
        const rect = showMoreBtn.getBoundingClientRect();
        if (rect.top <= window.innerHeight + 100 && showMoreBtn.style.display !== 'none') {
            loadProducts();
        }
    });
    updateUI();
});